<p-toast />
<form
  [formGroup]="formClaimetDetails"
  (ngSubmit)="nextStep()"
  class="w-full relative mt-6"
>
  <section class="personalInformation">
    <span class="titleSection">Datos empresa</span>
    <div class="grid w-full mb-2 mt-3">
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Razón Social <span class="span">*</span></label
        >
        <input
          placeholder="Razón social"
          formControlName="claimetCompany"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">CUIT <span class="span">*</span></label>
        <input
          pInputText
          placeholder="99-99999999-9"
          formControlName="claimetCompanyCuit"
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Correo electrónico <span class="span">*</span></label
        >
        <input
          placeholder="Correo electrónico"
          formControlName="company_email"
          pInputTextarea
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Teléfono</label>
        <input
          placeholder="Teléfono"
          formControlName="claimetCompanyPhone"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Calle <span class="span">*</span></label>
        <input
          placeholder="Calle"
          formControlName="claimetStreet"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-2 lg:col-2 xl:col-2 sm:col-6">
        <label class="labelTitle">Número <span class="span">*</span></label>
        <input
          placeholder="Número"
          formControlName="claimetNumber"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-2 lg:col-2 xl:col-2 sm:col-6">
        <label class="labelTitle">Piso/Depto</label>
        <input
          placeholder="Piso/Depto"
          formControlName="claimetFloorApartament"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-2 lg:col-2 xl:col-2 sm:col-6">
        <label class="labelTitle">Torre</label>
        <input
          placeholder="Torre"
          formControlName="claimetTower"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Código postal <span class="span">*</span></label
        >
        <input
          placeholder="Código postal"
          formControlName="claimetPostalCode"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Provincia<span class="span">*</span></label>
        <input
          pInputText
          formControlName="claimetProvince"
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Localidad<span class="span">*</span></label>
        <input
          pInputText
          formControlName="claimetCity"
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Persona<span class="span">*</span></label>
        <input
          [readOnly]="true"
          class="disabled"
          formControlName="claimetTypePerformance"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Departamento laboral<span class="span">*</span></label
        >
        <p-dropdown
          placeholder="Seleccione una opción"
          [options]="departments"
          optionLabel="name"
          optionValue="id"
          formControlName="department_id"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('department_id', 'required')
          }"
        />
      </div>
    </div>
    <div class="flex align-items-center gap-2 mt-5">
      <span class="span">*</span>
      <p-checkbox
        (onChange)="onConsentChange($event)"
        [binary]="true"
        formControlName="consent"
        class="check-acceptsElectronicDomicile"
        label="El domicilio electrónico constituido a través de la indicación de un correo electrónico, se considerará a todos los efectos jurídicos como domicilio constituído, siendo válidas y vinculantes las notificaciones, emplazamientos, comunicaciones y citaciones que se practiquen en el mismo, gozando de plena validez y eficacia su constitución."
      />
    </div>
  </section>
  <p-divider></p-divider>
  <section class="employmentRelationshipDetails mt-3">
    <span class="titleSection">Datos personales</span>
    <div class="grid w-full mb-2 mt-3">
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Apellido/s <span class="span">*</span></label>
        <input
          [readOnly]="true"
          class="disabled"
          placeholder="Apellido/s"
          formControlName="claimetLastname"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Nombre/s <span class="span">*</span></label>
        <input
          placeholder="Nombre/s"
          formControlName="claimetName"
          [readOnly]="true"
          class="disabled"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Cuil <span class="span">*</span></label>
        <input
          pInputText
          [readOnly]="true"
          class="disabled"
          formControlName="claimetCuil"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Cargo que ocupa en la empresa <span class="span">*</span></label
        >
        <input
          placeholder="Cargo que ocupa en la empresa"
          formControlName="claimetPosition"
          [readOnly]="true"
          class="disabled"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Teléfono</label>
        <input
          formControlName="claimetPhone"
          [readOnly]="true"
          class="disabled"
          placeholder="Teléfono"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Correo electrónico <span class="span">*</span></label
        >
        <input
          placeholder="Correo electrónico"
          formControlName="claimetEmail"
          [readOnly]="true"
          class="disabled"
          type="text"
          pInputText
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">
          Provincia <span class="span">*</span>
        </label>
        <input
          pInputText
          id="province_display"
          formControlName="claimetProvinceUser"
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"> Localidad <span class="span">*</span></label>
        <input
          pInputText
          id="city_display"
          formControlName="claimetLocalityUser"
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"> Calle </label>
        <input
          placeholder="Calle"
          formControlName="claimetStreetUser"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"> Número</label>
        <input
          placeholder="Número"
          formControlName="claimetNumberUser"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"> Piso/Depto </label>
        <input
          placeholder="Piso/Depto"
          formControlName="claimetFloorApartmentUser"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"> Código postal </label>
        <input
          placeholder="Código postal"
          formControlName="claimetPostalCodeUser"
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"> Fecha de nacimiento</label>
        <input
          [value]="
            formClaimetDetails.get('claimetBirthDateUser')?.value
              | date : 'dd/MM/yyyy'
          "
          pInputText
          [readOnly]="true"
          class="disabled"
        />
      </div>
    </div>
  </section>
  <p-divider></p-divider>
  <section class="attachedFiles mt-3">
    <span class="titleSection">Archivos adjuntos</span>
    <div class="grid w-full mt-3">
      <div class="col-12">
        <label class="labelTitle">Documentos<span class="span">*</span></label>
        <p class="descriptionContent mb-0">
          Cargue el documento que acredite la representación que invoca.
        </p>
      </div>

      <div class="col-12 md:col-8 lg:col-8 xl:col-6">
        <div
          [ngClass]="
            isDragging
              ? 'isDragging dropzone-container h-6rem col-12 '
              : 'dropzone-container h-6rem col-12 '
          "
          (dragover)="onDragOver($event)"
          (drop)="onDropSuccess($event, 'receipt')"
        >
          <input
            #inputFilePfd
            type="file"
            multiple="false"
            (change)="onChange($event, 'receipt')"
            accept=".pdf, .jpg, .png"
          />

          <div
            class="w-full flex align-items-center justify-content-between col-12"
          >
            <img
              class="hidden md:block"
              src="../../../../../../../assets/img/main/file-update.svg"
            />
            <span class="descriptionContent hidden md:block"
              >Arrastre sus documentos aquí o</span
            >
            <p-button
              pRipple
              (click)="inputFilePfd.click()"
              #upload
              class="btnUploadFile mr-1"
              >Elegir archivo</p-button
            >
          </div>
        </div>
        <span class="descriptionContent"
          >Archivos permitidos: JPG / JPEG / WEBP / HEIF / PDF / PNG
        </span>
      </div>
      <div class="col-12 md:col-4 lg:col-4 xl:col-6">
        <div
          class="text-danger p-error"
          *ngIf="
            formClaimetDetails
              .get('claimetFilePaycheck')
              ?.hasError('fileCount') &&
            formClaimetDetails.get('claimetFilePaycheck')?.touched
          "
        >
          Se deben subir entre 1 y 12 archivos.
        </div>
        <div
          class="conteiner-UploadRight-pdf"
          *ngFor="let pdf of pdfFiles; let i = index"
        >
          <img
            src="../../../../../../../assets/img/main/icon-image.svg"
            alt=""
            class="icon-imagen"
          />
          <span class="descriptionContent">{{ pdf.name }}</span>
          <p-button
            icon="pi pi-times"
            [rounded]="true"
            [text]="true"
            severity="danger"
            (onClick)="deleteFilePfd(i)"
          ></p-button>
        </div>
      </div>
    </div>
  </section>
  <div class="grid w-full flex justify-content-end">
    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        (click)="cancel()"
        label="Cancelar"
        class="btn-cancelar sm:text-xs"
      />
    </div>

    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        label="Siguiente"
        class="btn-siguiente"
        type="submit"
        [disabled]="formClaimetDetails.invalid"
      ></p-button>
    </div>
  </div>
</form>
